import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import RequireAuth from './RequireAuth';
import {
    GPerformanceDataManagement,
    GDomesticAuthManagement,
    GStructureReviewManagement,
    GSoundInsulationCalculationManagement,
} from "../components/GPublish";

// LossCalculator는 globals.css(html/body 전역 스타일)를 사용하므로,
// lazy 로드하여 해당 라우트 접근 시에만 적용되도록 함 (전체 앱 배율 축소 방지)
const LossCalculator = lazy(() => import("../components/LossCalculator/LossCalculator"));

// 납품확인서 관리
const PublishRoute = ({sessionUser}) => {

    return (
        <>
            {/* 성능확인서 발급 관리 */}
            <Route path="/gperformanceDatas" element={
                <RequireAuth sessionUser={sessionUser}>
                    <GPerformanceDataManagement />
                </RequireAuth>
            } />

            {/* 국내산인증서 발급 관리 */}
            <Route path="/gdomesticAuths" element={
                <RequireAuth sessionUser={sessionUser}>
                    <GDomesticAuthManagement />
                </RequireAuth>
            } />

            {/* 구조검토서 쿠라레 */}
            <Route path="/structureReviewsByKuraray" element={
                <RequireAuth sessionUser={sessionUser}>
                    <GStructureReviewManagement />
                </RequireAuth>
            } />

            {/* 차음성능계산서 쿠라레 */}
            <Route path="/soundInsulationCalculationByKuraray" element={
                <RequireAuth sessionUser={sessionUser}>
                    <GSoundInsulationCalculationManagement />
                </RequireAuth>
            } />

            {/* 유리 원판 Loss 계산기 */}
            <Route path="/lossCalculator" element={
                <RequireAuth sessionUser={sessionUser}>
                    <Suspense fallback={null}>
                        <LossCalculator />
                    </Suspense>
                </RequireAuth>
            } />
        </>
    );
};

export default PublishRoute;

